import Link from 'next/link';
import { Layout, CtaForm } from '../../components';
import { FeatureIcon } from '../../components/Svg';

const ARTICLES = [
	{
		id: 'automated-checklist-generator',
		icon: 5,
		title: 'Automated Checklist Generator',
		link:'https://blog.facilitybot.co/blog/knowledge-base/manager-web-portal/checklists/',
		description: 'The Automated Checklist Generator instantly creates structured inspection workflows from simple text prompts, such as "Monthly HVAC Inspection." It automatically builds standardized sections and items, drastically reducing manual setup time while ensuring operational consistency across different sites. This feature is ideal for streamlining recurring inspections, audits, and compliance procedures.'
	},
	{
		id: 'smart-checklist-import',
		icon: 9,
		title: 'Smart Checklist Import',
		link:'https://blog.facilitybot.co/blog/knowledge-base/manager-web-portal/smart-checklist-import-powered-by-chatgpt/',
		description: 'Smart Checklist Import transforms existing documents like PDFs or images into digital checklists within FacilityBot. The AI automatically detects checklist items and structures them into logical sections, removing the friction of manual copy-pasting. It is the perfect tool for operations teams looking to transition smoothly from legacy, paper-based processes to digital workflows.'
	},
	{
		id: 'smart-email-parsing',
		icon: 49,
		title: 'Smart Email Parsing',
		link:'https://blog.facilitybot.co/blog/knowledge-base/manager-web-portal/smart-email-parsing-powered-by-generative-ai/',
		description: 'Smart Email Parsing automatically reads incoming emails and extracts critical details like request types, locations, and descriptions. By intelligently populating fields directly from the email content, it significantly minimizes manual data entry. This automated triage ensures faster operational response times and maintains highly accurate, clean request records.'
	},
	{
		id: 'asset-insights',
		icon: 19,
		title: 'Asset Insights',
		link:'https://blog.facilitybot.co/blog/knowledge-base/manager-web-portal/asset-insights-powered-by-generative-ai/',
		description: 'Asset Insights automatically analyzes historical data to deliver concise, actionable summaries of asset performance instead of requiring manual log reviews. Summarize asset issues. Perform asset replace vs repair analysis. Predict the likelihood of asset failures using past asset data.'
	},
	{
		id: 'data-insights',
		icon: 22,
		title: 'Data Insights',
		link:'https://blog.facilitybot.co/blog/knowledge-base/uncategorized/insights-generative-ai-feature/',
		description: 'The Insights feature translates raw operational data into tables and charts simply via prompting. This makes it an invaluable asset for compiling quick summaries for management reviews, stakeholder updates, and comprehensive reports.'
	},
	{
		id: 'ai-knowledge',
		icon: 35,
		title: 'AI Knowledge',
		description: 'Upload your site SOPs and Equipment Manuals to AI Knowledge. Together with a central repository of equipment manuals, the AI Knowledge chatbot provides valuable assistance to technicians, without them needed to crawl through voluminous SOPs and Equipment Manuals.'
	},
	{
		id: 'ai-fault-reporting',
		icon: 18,
		title: 'AI Fault Reporting',
		description: 'Simply upload an image while fault reporting, and the AI will extract the likely issue to be submitted as a fault report ticket.'
	},
	{
		id: 'facilitybot-studio',
		icon: 17,
		title: 'FacilityBot Studio',
		description: 'Using AI for rapid prototyping, the FacilityBot Studio allows the rapid creation of custom apps, dashboards and add-ons to cater to the specific needs of your building operations.'
	}
];

export default function GenerativeAi() {
	return (
		<Layout pageName="Generative AI Features">
			<div className="feature">
				<section className="heading-container">
					<div className="container">
						<div className="heading">
							<h1 className="heading__title">Generative AI Features</h1>
							<h2 className="heading__desc">FacilityBot is a Generative AI-enabled CMMS System</h2>
						</div>
					</div>
				</section>

				<section className="feature-articles">
					<div className="container">
						<div className="feature-articles__wrapper">
							{ARTICLES.map(({ title, description, icon, id, link }, index) => {
								return (
									<article key={index} id={id} className="feature-article feature-article--w50">
										<div className="feature-article__icon">
											{FeatureIcon(icon)}
										</div>
										<Link href={link || '#'} target={link ? '_blank' : '_self'} rel='noopener noreferrer' className="feature-article__title feature-article__title-link">{title}</Link>
										<div className="feature-article__desc">{description}</div>
									</article>
								);
							})}
						</div>
					</div>
				</section>

				<div className="pricing-wrapper">
					<div className="container">
						<h2 className="pricing-wrapper__title">
							Generative AI features are available with the Professional and Plus Plans
							<br />
							Token top-up packs are available at USD 200 per month for an additional 5,000,000 tokens per month
						</h2>

						<button className="btn btn--plans">
							<Link href="/pricing-plans">view plans and pricing</Link>
						</button>
					</div>
				</div>

				<CtaForm />
			</div>
		</Layout>
	);
}
